(() => {
  const format = value => new Intl.NumberFormat('pl-PL', { maximumFractionDigits: 1 }).format(value);
  const price = value => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN', maximumFractionDigits: 0 }).format(Number(value) || 0);
  const escapeHtml = value => String(value || '').replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  const roundUp = value => Math.ceil(value * 10) / 10;

  const nominalPower = product => {
    const title = String(product.title || '').toUpperCase();
    if (title.includes('TH2000I')) return 1.8;
    if (title.includes('3600')) return 2.5;
    if (title.includes('3900')) return 2.8;
    if (title.includes('6500')) return 5;
    if (title.includes('8000') || title.includes('8990')) return 6;
    if (title.includes('9000') || title.includes('10990')) return 7;
    return 0;
  };

  const voltage = product => {
    const haystack = `${product.title || ''} ${(product.tags || []).join?.(' ') || product.tags || ''}`.toUpperCase();
    if (haystack.includes('DUAL POWER') || haystack.includes('DP')) return 'dual';
    if (haystack.includes('THT') || haystack.includes('400 V') || haystack.includes('TRÓJFAZ')) return '400';
    return '230';
  };

  const priority = product => {
    const title = String(product.title || '').toUpperCase();
    if (title.includes('TH2000I')) return 0;
    if (title.includes('E')) return 2;
    return 1;
  };

  async function loadProducts() {
    try {
      const response = await fetch('/collections/agregaty-mobilne/products.json?limit=250', { credentials: 'same-origin' });
      if (!response.ok) throw new Error(String(response.status));
      const data = await response.json();
      return (data.products || []).map(product => ({
        product,
        power: nominalPower(product),
        voltage: voltage(product),
        priority: priority(product),
        image: product.images?.[0]?.src || product.image?.src || '',
        variant: product.variants?.[0] || {}
      })).filter(item => item.power > 0);
    } catch (error) {
      return [];
    }
  }

  const injectStyles = () => {
    if (document.getElementById('kpcx-clarity-styles')) return;
    const style = document.createElement('style');
    style.id = 'kpcx-clarity-styles';
    style.textContent = `
      .kpcx-clarity{display:grid;gap:5px;margin:0 0 14px;padding:14px 16px;border-left:4px solid #36a765;background:#14241b;color:#dcebe2;font-size:12px;line-height:1.5}
      .kpcx-clarity strong{color:#fff;font-size:13px}
      .kpcx-example-set{display:flex;align-items:center;justify-content:space-between;gap:16px;margin:0 0 14px;padding:13px 15px;border:1px solid #41484d;background:#101315;color:#d7dbde;font-size:12px;line-height:1.45}
      .kpcx-example-set button{flex:0 0 auto;min-height:38px;border:0;background:#e31e24;color:#fff;padding:8px 13px;font-weight:900;cursor:pointer}
      @media(max-width:620px){.kpcx-example-set{display:grid}.kpcx-example-set button{width:100%}}
    `;
    document.head.appendChild(style);
  };

  function clarifyCalculator(root) {
    injectStyles();

    const introAside = root.querySelector('.kpcx-intro aside p');
    if (introAside) introAside.textContent = 'Rozruch trwa krótko i nie oznacza, że agregat musi być trzy razy mocniejszy od całego zestawu. Kalkulator dodaje tylko największy pojedynczy skok rozruchowy.';

    const secondPanel = root.querySelectorAll('.kpcx-panel')[1];
    const panelHead = secondPanel?.querySelector('.kpcx-panel-head');
    if (panelHead && !secondPanel.querySelector('.kpcx-clarity')) {
      const clarity = document.createElement('div');
      clarity.className = 'kpcx-clarity';
      clarity.innerHTML = '<strong>Lodówka 200–300 W nie jest trudnym odbiornikiem dla TH3900.</strong>Przy założeniu rozruchu ×3 chwilowy pobór wynosi około 600–900 W. TH3900 ma 2,8 kW mocy nominalnej i 3,2 kW maksymalnej, więc nadal pozostaje duży zapas na piec, światło i elektronikę.';
      panelHead.insertAdjacentElement('afterend', clarity);
    }

    const deviceCopy = {
      'Lodówka': { watts: 250, text: 'typowo 200–300 W · rozruch chwilowy do ×3' },
      'Zamrażarka': { watts: 250, text: 'typowo 200–300 W · rozruch chwilowy do ×3' },
      'Piec CO i sterownik': { watts: 180, text: 'typowo 100–250 W · mały pobór' },
      'Pompa obiegowa': { watts: 100, text: 'typowo 50–150 W · krótki rozruch' },
      'Oświetlenie domu': { watts: 300, text: 'typowy zestaw LED · bez rozruchu' },
      'TV, router i laptop': { watts: 350, text: 'typowy zestaw elektroniki' },
      'Hydrofor': { watts: 1000, text: 'przykład 1000 W · sprawdź konkretny rozruch' },
      'Pompa głębinowa': { watts: 1100, text: 'przykład 1100 W · sprawdź konkretny rozruch' }
    };

    root.querySelectorAll('.kpcx-device').forEach(row => {
      const item = deviceCopy[row.dataset.name];
      if (!item) return;
      row.dataset.watts = String(item.watts);
      const small = row.querySelector('small');
      if (small) small.textContent = item.text;
    });

    const homeGroup = root.querySelector('[data-group="dom"]');
    if (homeGroup && !homeGroup.querySelector('.kpcx-example-set')) {
      const example = document.createElement('div');
      example.className = 'kpcx-example-set';
      example.innerHTML = '<span><strong>Przykład: podstawowe zasilanie awaryjne domu</strong><br>Lodówka + zamrażarka + piec CO + pompa obiegowa + światło + internet i elektronika.</span><button type="button" data-kpcx-home-example>Wczytaj przykład</button>';
      const devices = homeGroup.querySelector('.kpcx-devices');
      devices?.insertAdjacentElement('beforebegin', example);
    }
  }

  function init(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    clarifyCalculator(root);

    const state = { voltage: '230', use: 'dom', margin: 20, custom: [] };
    const voltageButtons = [...root.querySelectorAll('[data-voltage]')];
    const useButtons = [...root.querySelectorAll('[data-use]')];
    const margin = root.querySelector('[data-margin]');
    const marginOutput = root.querySelector('[data-margin-output]');
    const countOutput = root.querySelector('[data-device-count]');
    const voltageOutput = root.querySelector('[data-voltage-output]');
    const continuousOutput = root.querySelector('[data-continuous]');
    const startupOutput = root.querySelector('[data-startup]');
    const recommendedOutput = root.querySelector('[data-recommended]');
    const meter = root.querySelector('[data-meter]');
    const status = root.querySelector('[data-status]');
    const advisor = root.querySelector('[data-advisor]');
    const showModels = root.querySelector('[data-show-models]');
    const modelsSection = root.querySelector('[data-models-section]');
    const modelGrid = root.querySelector('[data-model-grid]');
    const emptyModels = root.querySelector('[data-empty-models]');
    const customForm = root.querySelector('[data-custom-form]');
    const customList = root.querySelector('[data-custom-list]');
    const productsPromise = loadProducts();

    const selectedDevices = () => {
      const preset = [...root.querySelectorAll('.kpcx-device')].map(row => {
        const quantity = Math.max(0, Number(row.querySelector('input')?.value) || 0);
        return {
          name: row.dataset.name || '',
          watts: Number(row.dataset.watts) || 0,
          start: Number(row.dataset.start) || 1,
          quantity
        };
      }).filter(item => item.quantity > 0);
      return [...preset, ...state.custom];
    };

    const result = () => {
      const devices = selectedDevices();
      const continuousW = devices.reduce((sum, item) => sum + item.watts * item.quantity, 0);
      const largestStartDelta = devices.reduce((max, item) => Math.max(max, item.watts * Math.max(0, item.start - 1)), 0);
      const startupW = continuousW + largestStartDelta;
      const recommendedW = Math.max(continuousW * (1 + state.margin / 100), startupW * 1.1);
      return {
        devices,
        continuous: continuousW / 1000,
        startup: startupW / 1000,
        recommended: roundUp(recommendedW / 1000)
      };
    };

    const voltageLabel = () => state.voltage === '400' ? '400 V' : state.voltage === 'dual' ? '230/400 V Dual Power' : '230 V';

    const renderCustom = () => {
      if (!customList) return;
      customList.innerHTML = state.custom.map(item => `<div class="kpcx-custom-row" data-custom-id="${item.id}"><span><strong>${escapeHtml(item.name)}</strong> — ${item.watts} W, rozruch ×${item.start}</span><button type="button">Usuń</button></div>`).join('');
    };

    const update = () => {
      const data = result();
      if (countOutput) countOutput.textContent = String(data.devices.reduce((sum, item) => sum + item.quantity, 0));
      if (voltageOutput) voltageOutput.textContent = voltageLabel();
      if (continuousOutput) continuousOutput.textContent = `${format(data.continuous)} kW`;
      if (startupOutput) startupOutput.textContent = `${format(data.startup)} kW`;
      if (recommendedOutput) recommendedOutput.textContent = `${format(data.recommended)} kW`;
      if (meter) meter.style.width = `${Math.min(100, Math.max(data.devices.length ? 4 : 0, data.recommended / 9 * 100))}%`;

      if (status) {
        if (!data.devices.length) {
          status.innerHTML = '<strong>Dodaj urządzenia.</strong> Podstawowy zestaw domowy możesz też wczytać jednym kliknięciem.';
        } else if (data.recommended <= 2.5) {
          status.innerHTML = '<strong>Duży zapas w TH3900.</strong> Ten zestaw mieści się już w klasie 2,5 kW, a TH3900 daje dodatkową rezerwę.';
        } else if (data.recommended <= 2.8) {
          status.innerHTML = '<strong>TH3900 jest dopasowany.</strong> Obliczone zapotrzebowanie wraz z rozruchem i zapasem mieści się w 2,8 kW mocy nominalnej.';
        } else if (data.recommended <= 5) {
          status.innerHTML = '<strong>Potrzebny większy zapas.</strong> Sprawdź TH6500 o mocy nominalnej 5,0 kW.';
        } else if (data.recommended <= 7) {
          status.innerHTML = '<strong>Wysoki zakres mobilny.</strong> Sprawdź modele 6–7 kW.';
        } else {
          status.innerHTML = '<strong>Wynik przekracza typowy zakres mobilny.</strong> Skonsultuj agregat stacjonarny lub podział odbiorników.';
        }
      }

      if (advisor) {
        const devices = data.devices.map(item => `${item.name} ×${item.quantity} (${item.watts} W)`).join(', ') || 'brak';
        advisor.href = `mailto:sklep@kruzer.pl?subject=${encodeURIComponent(`Dobór agregatu KRUZER — ${format(data.recommended)} kW, ${voltageLabel()}`)}&body=${encodeURIComponent(`Dzień dobry, proszę o potwierdzenie doboru agregatu.\n\nNapięcie: ${voltageLabel()}\nZastosowanie: ${state.use}\nMoc ciągła: ${format(data.continuous)} kW\nSzczyt rozruchowy: ${format(data.startup)} kW\nRekomendowana moc: ${format(data.recommended)} kW\nUrządzenia: ${devices}`)}`;
      }
    };

    const renderModels = async () => {
      const data = result();
      const products = await productsPromise;
      const sameVoltage = products.filter(item => item.voltage === state.voltage).sort((a, b) => a.power - b.power || a.priority - b.priority);
      const sufficient = sameVoltage.filter(item => item.power + 0.001 >= Math.max(.1, data.recommended));
      const chosen = (sufficient.length ? sufficient : sameVoltage.slice().sort((a, b) => b.power - a.power)).slice(0, 3);
      if (modelGrid) {
        modelGrid.innerHTML = chosen.map(item => `<a class="kpcx-model" href="/products/${item.product.handle}"><div class="kpcx-model__image">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product.title)}" loading="lazy">` : ''}</div><div class="kpcx-model__body"><small>${item.voltage === 'dual' ? 'Dual Power 230/400 V' : `${item.voltage} V`} · ${format(item.power)} kW nominalnie</small><h3>${escapeHtml(item.product.title)}</h3><strong>${price(item.variant.price)}</strong><span>Zobacz model →</span></div></a>`).join('');
      }
      if (emptyModels) {
        emptyModels.hidden = chosen.length > 0;
        if (!chosen.length) emptyModels.innerHTML = 'Nie znaleźliśmy właściwego modelu dla tego wyniku. <a href="tel:+48531026666">Zadzwoń: 531 026 666 →</a>';
      }
      if (modelsSection) {
        modelsSection.hidden = false;
        requestAnimationFrame(() => modelsSection.scrollIntoView({ behavior: 'smooth', block: 'start' }));
      }
    };

    root.addEventListener('click', event => {
      const exampleButton = event.target.closest('[data-kpcx-home-example]');
      if (exampleButton) {
        const names = new Set(['Lodówka', 'Zamrażarka', 'Piec CO i sterownik', 'Pompa obiegowa', 'Oświetlenie domu', 'TV, router i laptop']);
        root.querySelectorAll('.kpcx-device').forEach(row => {
          const input = row.querySelector('input');
          if (input) input.value = names.has(row.dataset.name) ? '1' : '0';
        });
        state.voltage = '230';
        voltageButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.voltage === '230')));
        update();
        root.querySelector('.kpcx-summary')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }

      const qty = event.target.closest('[data-qty]');
      if (qty) {
        const input = qty.closest('.kpcx-qty')?.querySelector('input');
        if (input) input.value = String(Math.max(0, Math.min(9, (Number(input.value) || 0) + (qty.dataset.qty === 'plus' ? 1 : -1))));
        update();
        return;
      }

      const customRemove = event.target.closest('.kpcx-custom-row button');
      if (customRemove) {
        const id = customRemove.closest('[data-custom-id]')?.dataset.customId;
        state.custom = state.custom.filter(item => item.id !== id);
        renderCustom();
        update();
      }
    });

    root.addEventListener('input', event => {
      if (event.target.matches('.kpcx-device input')) update();
    });

    voltageButtons.forEach(button => button.addEventListener('click', () => {
      state.voltage = button.dataset.voltage;
      voltageButtons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      update();
    }));

    useButtons.forEach(button => button.addEventListener('click', () => {
      state.use = button.dataset.use;
      useButtons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const group = root.querySelector(`[data-group="${state.use}"]`);
      if (group) group.open = true;
      update();
    }));

    margin?.addEventListener('input', () => {
      state.margin = Number(margin.value) || 20;
      if (marginOutput) marginOutput.textContent = `${state.margin}%`;
      update();
    });

    customForm?.addEventListener('submit', event => {
      event.preventDefault();
      const form = new FormData(customForm);
      const name = String(form.get('name') || '').trim();
      const watts = Math.max(1, Number(form.get('watts')) || 0);
      const start = Math.max(1, Number(form.get('start')) || 1);
      if (!name || !watts) return;
      state.custom.push({ id: `${Date.now()}-${Math.random()}`, name, watts, start, quantity: 1 });
      customForm.reset();
      renderCustom();
      update();
    });

    showModels?.addEventListener('click', renderModels);
    update();
  }

  const boot = () => document.querySelectorAll('[data-kpcx]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
